// src/App.js
import React, { useState, useEffect } from 'react';
import { LocationPinMap } from 'material-ui-location-pin-map';

function App() {
  const [mapData, setMapData] = useState(null);

  useEffect(() => {
    // Get geojson_url from URL parameters
    const urlParams = new URLSearchParams(window.location.search);
    const geojsonUrl = urlParams.get('geojson_url');

    if (geojsonUrl) {
      fetch(geojsonUrl)
        .then(response => response.json())
        .then(data => setMapData(data))
        .catch(error => console.error('Error fetching GeoJSON:', error));
    } else {
      console.error('No geojson_url parameter provided in URL');
    }
  }, []);

  return (
    <div>
      {mapData ? (
        <LocationPinMap
          data={mapData}
          title={"Locations"}
          accessToken={process.env.REACT_APP_MAPBOX_ACCESS_TOKEN}
        />
      ) : (
        <div>Loading map...</div>
      )}
    </div>
  );
}

export default App;